import {
    SliceFactory,
    FetchCollectionData,
    ApiCollectionResponse,
    FetchItemDataType,
} from '@europrocurement/l2d-redux-utils';
import {
    ConfigurationParameters as FormalityApiConfigurationParameters,
    Configuration,
    LogActionDossierLogActionDtoJsonldLogRead,
    ActionLoggerApi,
    ActionLoggerApiApiLogActionDossiersGetActionLoggerDossierCollectionRequest,
} from '../../../openApi/ApiFormalite';
import { DOSSIER_LOG_ACTION_SLICE_NAME, FORMALITES_REDUCER_NAME } from '../constants';

export type DossierLogActionApiObject = LogActionDossierLogActionDtoJsonldLogRead &
    Record<string, unknown>;

export type DossierLogAction = DossierLogActionApiObject;

export const mapperDossierLogAction = function (logActionDossier: DossierLogAction) {
    return {
        ...logActionDossier,
    } as DossierLogAction;
};

export function createDossierLogActionSlice(configuration: FormalityApiConfigurationParameters) {
    const conf = new Configuration(configuration);
    const api = new ActionLoggerApi(conf);

    const fetchDossierLogActionCollection: FetchCollectionData<DossierLogAction> = ({
        pagination,
        filters,
    }) => {
        const { entityId, withTech, isClient } = filters;

        if (isClient) {
            const requestParameters: ActionLoggerApiApiLogActionDossiersGetActionLoggerDossierCollectionRequest =
                {
                    page: pagination.page + 1,
                    itemsPerPage: 100,
                    entityId: entityId as number,
                };

            return api
                .apiLogActionDossiersGetActionLoggerDossierClientCollection(requestParameters)
                .then((res) => res.data) as Promise<ApiCollectionResponse<DossierLogAction>>;
        }
        const requestParameters: ActionLoggerApiApiLogActionDossiersGetActionLoggerDossierCollectionRequest =
            {
                page: pagination.page + 1,
                itemsPerPage: 100,
                entityId: entityId as number,
                withTech: withTech as boolean,
            };

        return api
            .apiLogActionDossiersGetActionLoggerDossierCollection(requestParameters)
            .then((res) => res.data) as Promise<ApiCollectionResponse<DossierLogAction>>;
    };

    const fetchDossierLogActionItem: FetchItemDataType<DossierLogAction> = ({ idItem }) => {
        const requestParameters: ActionLoggerApiApiLogActionDossiersGetActionLoggerDossierCollectionRequest =
            {
                entityId: idItem as number,
            };

        return api
            .apiLogActionDossiersGetActionLoggerDossierCollection(requestParameters)
            .then((res) => res.data) as Promise<DossierLogAction>;
    };

    const { slice: dossierLogActionSlice, dataSourcesThunks: dossierLogActionDataSourcesThunks } =
        SliceFactory.createSlice<DossierLogAction, DossierLogAction>(
            DOSSIER_LOG_ACTION_SLICE_NAME,
            FORMALITES_REDUCER_NAME,
            [],
            fetchDossierLogActionCollection,
            fetchDossierLogActionItem,
            mapperDossierLogAction,
            {},
            undefined,
            [],
        );

    return { dossierLogActionSlice, dossierLogActionDataSourcesThunks };
}
